
    var riot = require('riot')
    //src: starling/src/tags/export-menu.html
riot.tag2('export-menu',
  '<ul ref="menuList" class="floating-menu_list"> <li onclick="{beginImageDownload}" data-track="{getTrackingLabel()}" data-track-action="Export-Image" data-track-label="Export" class="floating-menu_item {this.canvas.store.getNodesSize() == 0 && \'floating-menu_item--disabled\'}"> <i class="fa fa-image floating-menu_icon" aria-hidden="true"></i> <form ref="imageForm" class="screenshot-form " method="POST" action="{window.config.services.screenshot.host}/download/image/png"> <input ref="imageHTMLField" id="image-html" type="hidden" name="html" value=""> <input ref="imageHeightField" id="image-height" type="hidden" name="height" riot-value="{window.innerHeight}"> <input ref="imageWidthField" id="image-width" type="hidden" name="width" riot-value="{window.innerWidth}"> <input ref="imageTokenField" id="image-token" type="hidden" name="token" value=""> <input ref="imageTitleField" type="hidden" name="title" riot-value="{encodeURIComponent(this.canvas.store.getTitle())}"> <span class="floating-menu_label">Image</span> </form> </li> <li onclick="{beginPDFDownload}" data-track="{getTrackingLabel()}" data-track-action="Export-PDF" data-track-label="Export" class="floating-menu_item {this.canvas.store.getNodesSize() == 0 && \'floating-menu_item--disabled\'}"> <i class="fa fa-file-pdf-o floating-menu_icon" aria-hidden="true"></i> <form ref="pdfForm" class="screenshot-form" method="POST" action="{window.config.services.screenshot.host}/download/pdf"> <input ref="pdfHTMLField" id="pdf-html" type="hidden" name="html" value=""> <input ref="pdfHeightField" id="pdf-height" type="hidden" name="height" riot-value="{window.innerHeight}"> <input ref="pdfWidthField" id="pdf-width" type="hidden" name="width" riot-value="{window.innerWidth}"> <input ref="pdfOrientationField" id="pdf-orientation" type="hidden" name="orientation" value=""> <input ref="pdfTokenField" id="pdf-token" type="hidden" name="token" value=""> <input ref="pdfTitleField" type="hidden" name="title" riot-value="{encodeURIComponent(this.canvas.store.getTitle())}"> <span class="floating-menu_label">PDF</span> </form> </li> <li onclick="{beginPPTDownload}" class="floating-menu_item {this.canvas.store.getNodesSize() == 0 && \'floating-menu_item--disabled\'}" data-track="{getTrackingLabel()}" data-track-action="Export-PPT" data-track-label="Export"> <svg class="file-icon floating-menu_icon"> <use xlink:href="#file-presentation-icon"></use> </svg> <form ref="pptForm" class="screenshot-form" method="POST" action="{window.config.services.powerpoint.host}/download/pptx"> <input ref="pptHTMLField" id="ppt-html" type="hidden" name="html" value=""> <input ref="pptSlidesField" id="ppt-slides" type="hidden" name="slides" value=""> <input ref="pptTokenField" id="ppt-token" type="hidden" name="token" value=""> <input ref="pptTitleField" type="hidden" name="title" riot-value="{encodeURIComponent(this.canvas.store.getTitle())}"> <input ref="pptHeightField" id="ppt-height" type="hidden" name="height" riot-value="{window.innerHeight}"> <input ref="pptWidthField" id="ppt-width" type="hidden" name="width" riot-value="{window.innerWidth}"> <input ref="pptPrintEntireMapField" id="ppt-printentiremap" type="hidden" name="print_entire_map" value=""> <input ref="pptBackgroundField" id="ppt-background" type="hidden" name="background" value=""> <span class="floating-menu_label">PowerPoint</span> </form> </li> <li if="{window.config.env == \'dev\'}" onclick="{this.downloadHTML}" data-track="{getTrackingLabel()}" data-track-action="Export-HTML" class="floating-menu_item floating-menu_item--iconless" data-track-label="Export"> <span class="floating-menu_label">HTML (dev)</span> </li> <li hide="{this.exportSelection || this.exportNode}" onclick="{openExportPage}" class="floating-menu_item floating-menu_item--iconless" data-track="{getTrackingLabel()}" data-track-action="Export-JSON/CSV" data-track-label="Export"> <span class="floating-menu_label">JSON / CSV</span> </li> </ul>',
  '',
  'riot-style="{this.getStyle()}" class="floating-menu floating-menu--hidden floating-menu--small" onmouseenter="{this.handlePanelMouseEnter}"', function(opts) {
'use strict';

var _this = this;

var _exportScreenshots = require('lib/export-screenshots');

var _util = require('lib/util.js');

var _delayHandler = require('lib/delay-handler');

this.canvas = opts.canvas;
this.operation = opts.operation;
this.canvas.exportMenu = this;
this.origin = null;
this.exportNode = null;
this.exportSelection = false;
this.width = 0;

this.hide = function () {
  _this.isOpen = false;
  _this.root.classList.add('floating-menu--hidden');
  _this.spawnRect = null;
  _this.positionToLeft = null;
  _this.exportNode = null;
  _this.exportSelection = false;
  _this.origin = null;
};

this.summon = function (_ref) {
  var exportSelection = _ref.exportSelection,
      exportNode = _ref.exportNode,
      spawnedFromElement = _ref.spawnedFromElement,
      positionToLeft = _ref.positionToLeft,
      origin = _ref.origin;

  _this.exportSelection = exportSelection;
  _this.exportNode = exportNode;
  _this.positionToLeft = positionToLeft;
  _this.origin = origin;
  _this.root.classList.remove('floating-menu--hidden');
  _this.discoverSize();
  if (spawnedFromElement) {
    var rect = spawnedFromElement.getBoundingClientRect();
    _this.left = rect.right;
    _this.top = rect.top;
    _this.spawnRect = rect;

    if (_this.fromOrigin('toolbar')) {
      _this.top = _this.spawnRect.bottom;
      _this.left = _this.spawnRect.left - _this.width / 2 + _this.spawnRect.width / 2;
    } else if (_this.positionToLeft) {
      _this.left = _this.spawnRect.left - _this.width;
    } else {
      _this.left = _this.spawnRect.right;
    }
    _this.root.style.top = _this.top;
    _this.root.style.left = _this.left;
  }
  _this.isOpen = true;
  _this.update();
};

this.fromOrigin = function (name) {
  return _this.origin === name;
};

this.discoverSize = function () {
  var menuRect = _this.root.getBoundingClientRect();
  _this.width = menuRect.width;
  _this.height = menuRect.height;
};

this.getStyle = function () {
  if (_this.top === undefined) {
    return '';
  }
  return 'top: ' + _this.top + 'px; left: ' + _this.left + 'px';
};

this.openExportPage = function () {
  window.open('/maps/' + _this.canvas.access.publicIdentifier + '/export');
  _this.canvas.mapMenuTag.hide();
};

this.downloadHTML = function () {
  _this.setExportedOption();
  _exportScreenshots.exportScreenshots.downloadHTML();
  _this.canvas.hidePopups();
};

this.beginImageDownload = function () {
  var _refs = _this.refs,
      imageHeightField = _refs.imageHeightField,
      imageWidthField = _refs.imageWidthField,
      imageHTMLField = _refs.imageHTMLField,
      imageTokenField = _refs.imageTokenField,
      imageForm = _refs.imageForm;

  _this.setExportedOption();
  _exportScreenshots.exportScreenshots.beginImageDownload({ imageHeightField: imageHeightField, imageWidthField: imageWidthField, imageHTMLField: imageHTMLField, imageTokenField: imageTokenField, imageForm: imageForm });
  _this.canvas.hidePopups();
};

this.beginPDFDownload = function () {
  var _refs2 = _this.refs,
      pdfHeightField = _refs2.pdfHeightField,
      pdfWidthField = _refs2.pdfWidthField,
      pdfOrientationField = _refs2.pdfOrientationField,
      pdfHTMLField = _refs2.pdfHTMLField,
      pdfTokenField = _refs2.pdfTokenField,
      pdfForm = _refs2.pdfForm;

  _this.setExportedOption();
  _exportScreenshots.exportScreenshots.beginPDFDownload({ pdfHeightField: pdfHeightField, pdfWidthField: pdfWidthField, pdfOrientationField: pdfOrientationField, pdfHTMLField: pdfHTMLField, pdfTokenField: pdfTokenField, pdfForm: pdfForm });
  _this.canvas.hidePopups();
};

this.beginPPTDownload = function () {
  var _refs3 = _this.refs,
      pptHeightField = _refs3.pptHeightField,
      pptWidthField = _refs3.pptWidthField,
      pptSlidesField = _refs3.pptSlidesField,
      pptHTMLField = _refs3.pptHTMLField,
      pptTokenField = _refs3.pptTokenField,
      pptPrintEntireMapField = _refs3.pptPrintEntireMapField,
      pptBackgroundField = _refs3.pptBackgroundField,
      pptForm = _refs3.pptForm;

  _this.setExportedOption();
  _exportScreenshots.exportScreenshots.beginPPTDownload({ pptHeightField: pptHeightField, pptWidthField: pptWidthField, pptHTMLField: pptHTMLField, pptSlidesField: pptSlidesField, pptTokenField: pptTokenField, pptPrintEntireMapField: pptPrintEntireMapField, pptBackgroundField: pptBackgroundField, pptForm: pptForm });
  _this.canvas.hidePopups();
};

this.setExportedOption = function () {
  if (_this.exportNode) {
    _exportScreenshots.exportScreenshots.setExportedElements([_this.exportNode]);
  } else if (_this.exportSelection) {
    _exportScreenshots.exportScreenshots.setExportedElements(_this.canvas.selectedElements);
  } else {
    _exportScreenshots.exportScreenshots.setExportedElements(null);
  }
};

this.getTrackingLabel = function () {
  return (0, _util.getTrackingLabel)({ menuName: _this.origin });
};

this.handlePanelMouseEnter = function () {
  _delayHandler.delayHandler.clearDelayFor('submenus');
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('export-menu')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/export-menu.html
// module id = 604
// module chunks = 0